export const colorItemImages = {
  red: [
    { id: 'RedWomanClothes', name: 'RedWomanClothes', imageUrl: '/image/red/red_woman_clothes.jpg' },
    { id: 'RedWomanS', name: 'RedWomanS', imageUrl: '/image/red/red_woman_s.jpg' },
    { id: 'RedWomanBag', name: 'RedWomanBag', imageUrl: '/image/red/red_woman_bag.jpg' },
    { id: 'RedWomanAcc', name: 'RedWomanAcc', imageUrl: '/image/red/red_woman_acc.jpg' },
    { id: 'RedMenClothes', name: 'RedMenClothes', imageUrl: '/image/red/red_men_clothes.jpg' },
    { id: 'RedMenS', name: 'RedMenS', imageUrl: '/image/red/red_men_s.jpg' },
    { id: 'RedMenBag', name: 'RedMenBag', imageUrl: '/image/red/red_men_bag.jpg' },
    { id: 'RedMenAcc', name: 'RedMenAcc', imageUrl: '/image/red/red_men_acc.jpg' },
    { id: 'RedHome', name: 'RedHome', imageUrl: '/image/red/red_home.jpg' },
    { id: 'RedKitchen', name: 'RedKitchen', imageUrl: '/image/red/red_kitchen.png' },
    { id: 'RedMachine', name: 'RedMachine', imageUrl: '/image/red/red_machine.jpg' },
    { id: 'RedLeisure', name: 'RedLeisure', imageUrl: '/image/red/red_leisure.jpg' },
  ],
  black: [
    { id: 'BlackWomanClothes', name: 'BlackWomanClothes', imageUrl: '/image/black/black_woman_clothes.jpg' },
    { id: 'BlackWomanS', name: 'BlackWomanS', imageUrl: '/image/black/black_woman_s.jpg' },
    { id: 'BlackWomanBag', name: 'BlackWomanBag', imageUrl: '/image/black/black_woman_bag.jpg' },
    { id: 'BlackWomanAcc', name: 'BlackWomanAcc', imageUrl: '/image/black/black_woman_acc.jpg' },
    { id: 'BlackMenClothes', name: 'BlackMenClothes', imageUrl: '/image/black/black_men_clothes.jpg' },
    { id: 'BlackMenS', name: 'BlackMenS', imageUrl: '/image/black/black_men_s.jpg' },
    { id: 'BlackMenBag', name: 'BlackMenBag', imageUrl: '/image/black/black_men_bag.jpg' },
    { id: 'BlackMenAcc', name: 'BlackMenAcc', imageUrl: '/image/black/black_men_acc.jpg' },
    { id: 'BlackHome', name: 'BlackHome', imageUrl: '/image/black/black_home.png' },
    { id: 'BlackKitchen', name: 'BlackKitchen', imageUrl: '/image/black/black_kitchen.jpg' },
    { id: 'BlackMachine', name: 'BlackMachine', imageUrl: '/image/black/black_machine.jpg' },
    { id: 'BlackLeisure', name: 'BlackLeisure', imageUrl: '/image/black/black_leisure.jpg' },
  ],
  white: [
    { id: 'WhiteWomanClothes', name: 'WhiteWomanClothes', imageUrl: '/image/white/white_woman_clothes.jpg' },
    { id: 'WhiteWomanS', name: 'WhiteWomanS', imageUrl: '/image/white/white_woman_s.jpg' },
    { id: 'WhiteWomanBag', name: 'WhiteWomanBag', imageUrl: '/image/white/white_woman_bag.jpg' },
    { id: 'WhiteWomanAcc', name: 'WhiteWomanAcc', imageUrl: '/image/white/white_woman_acc.jpg' },
    { id: 'WhiteMenClothes', name: 'WhiteMenClothes', imageUrl: '/image/white/white_men_clothes.jpg' },
    { id: 'WhiteMenS', name: 'WhiteMenS', imageUrl: '/image/white/white_men_s.jpg' },
    { id: 'WhiteMenBag', name: 'WhiteMenBag', imageUrl: '/image/white/white_men_bag.jpg' },
    { id: 'WhiteMenAcc', name: 'WhiteMenAcc', imageUrl: '/image/white/white_men_acc.jpg' },
    { id: 'WhiteHome', name: 'WhiteHome', imageUrl: '/image/white/white_home.jpg' },
    { id: 'WhiteKitchen', name: 'WhiteKitchen', imageUrl: '/image/white/white_kitchen.jpg' },
    { id: 'WhiteMachine', name: 'WhiteMachine', imageUrl: '/image/white/white_machine.jpg' },
    { id: 'WhiteLeisure', name: 'WhiteLeisure', imageUrl: '/image/white/white_leisure.jpg' },
  ],
  yellow: [
    { id: 'YellowWomanClothes', name: 'YellowWomanClothes', imageUrl: '/image/yellow/yellow_woman_clothes.jpeg' },
    { id: 'YellowWomanS', name: 'YellowWomanS', imageUrl: '/image/yellow/yellow_woman_s.jpg' },
    { id: 'YellowWomanBag', name: 'YellowWomanBag', imageUrl: '/image/yellow/yellow_woman_bag.jpg' },
    { id: 'YellowWomanAcc', name: 'YellowWomanAcc', imageUrl: '/image/yellow/yellow_woman_acc.jpg' },
    { id: 'YellowMenClothes', name: 'YellowMenClothes', imageUrl: '/image/yellow/yellow_men_clothes.jpg' },
    { id: 'YellowMenS', name: 'YellowMenS', imageUrl: '/image/yellow/yellow_men_s.jpg' },
    { id: 'YellowMenBag', name: 'YellowMenBag', imageUrl: '/image/yellow/yellow_men_bag.jpg' },
    { id: 'YellowMenAcc', name: 'YellowMenAcc', imageUrl: '/image/yellow/yellow_men_acc.jpg' },
    { id: 'YellowHome', name: 'YellowHome', imageUrl: '/image/yellow/yellow_home.jpg' },
    { id: 'YellowKitchen', name: 'YellowKitchen', imageUrl: '/image/yellow/yellow_kitchen.jpg' },
    { id: 'YellowMachine', name: 'YellowMachine', imageUrl: '/image/yellow/yellow_machine.jpg' },
    { id: 'YellowLeisure', name: 'YellowLeisure', imageUrl: '/image/yellow/yellow_leisure.jpg' },
  ],
  green: [
    { id: 'GreenWomanClothes', name: 'GreenWomanClothes', imageUrl: '/image/green/green_woman_clothes.jpg' },
    { id: 'GreenWomanS', name: 'GreenWomanS', imageUrl: '/image/green/green_woman_s.jpg' },
    { id: 'GreenWomanBag', name: 'GreenWomanBag', imageUrl: '/image/green/green_woman_bag.jpg' },
    { id: 'GreenWomanAcc', name: 'GreenWomanAcc', imageUrl: '/image/green/green_woman_acc.jpg' },
    { id: 'GreenMenClothes', name: 'GreenMenClothes', imageUrl: '/image/green/green_men_clothes.jpg' },
    { id: 'GreenMenS', name: 'GreenMenS', imageUrl: '/image/green/green_men_s.jpg' },
    { id: 'GreenMenBag', name: 'GreenMenBag', imageUrl: '/image/green/green_men_bag.jpg' },
    { id: 'GreenMenAcc', name: 'GreenMenAcc', imageUrl: '/image/green/green_men_acc.jpg' },
    { id: 'GreenHome', name: 'GreenHome', imageUrl: '/image/green/green_home.jpg' },
    { id: 'GreenKitchen', name: 'GreenKitchen', imageUrl: '/image/green/green_kitchen.jpg' },
    { id: 'GreenMachine', name: 'GreenMachine', imageUrl: '/image/green/green_machine.jpg' },
    { id: 'GreenLeisure', name: 'GreenLeisure', imageUrl: '/image/green/green_leisure.jpg' },
  ],
};
